import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { OrderService } from '../order.service';
import { ReceiptService } from '../receipt-service';

@Injectable({ providedIn: 'root' })
export class CheckoutRouteGuardService implements CanActivate {
  constructor(
    private readonly orderService: OrderService,
    private readonly receiptService: ReceiptService,
    @Inject(DOCUMENT) private documentService: Document
  ) {}

  public async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean>
  {
    try {
      const order = await this.orderService.getOrder(false);
      const orderIsEmpty = this.orderService.isEmpty(order);
      
      if (order !== null && !orderIsEmpty) {
          return true;
      }
      
      const orderForFmt = this.receiptService.getOrders().orderSubscription;
      
      if (orderForFmt !== null) {
          return true;
      }
      
      // Redirect to a safe route instead of just returning false
      this.documentService.location.href = '/';

      return false;
    } 
    catch (error) {
      this.documentService.location.href = '/';

      return false;
    }
  }
}

